<template>
  <div class="WSign">
    <div class="placeholder" v-if="!imgSrc" @click="handleSignature">
      点击添加签名
    </div>
    <el-image
      v-else
      :src="imgSrc"
      @error="handleError(itemValue.data[0])"
      @click.native="handleSignature"
    >
    </el-image>
    <signature
      v-if="visible"
      ref="signature"
      @handleSaveSignature="handleSaveSignature"
      @handleDefault="handleDefaultSignature"
      @handleClosed="handleClosed"
    />
    <ImageViewer
      v-if="visible"
      ref="imageViewer"
      :previewType="previewType"
      @closed="handleClosed"
    />
  </div>
</template>

<script>
import { getSystemVariables } from '@/api/dataSpec.js'
import ImageViewer from '@/components/ImageViewer'
import { downloadFile } from '@/api/largeFile.js'
import Signature from '@/components/Signature'
import upload from './mixin/upload'
export default {
  name: 'WSign',
  mixins: [upload],
  components: {
    Signature,
    ImageViewer
  },
  data() {
    return {
      uploadLimit: 1
    }
  },
  mounted() {
    this.getImg()
  },
  computed: {
    imgSrc() {
      if (this.itemValue && this.itemValue.data && this.itemValue.data.length) {
        if (this.itemValue.data[0].id) {
          if (this.itemValue.data[0].src) {
            return this.itemValue.data[0].src
          } if (this.itemValue.data[0].id) {
            return this.itemValue.data[0].src || ''
          }
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  methods: {
    // 默认签名
    async handleDefaultSignature() {
      var variables = (await getSystemVariables()).data
      if (variables[20] && variables[20].data && variables[20].data.length) {
        console.log(variables[20].data[0].id)
        downloadFile(variables[20].data[0].id).then(thumbnail => {
          this.handleSaveSignature(thumbnail.data)
        })
      } else {
        this.$essage.error({
          dangerouslyUseHTMLString: true,
          showClose: true,
          message: this.$t('report.defaultSignature'),
          type: 'error',
          duration: 5000
        })
      }
    },
    // 保存签名
    handleSaveSignature(base64) {
      // this.imgSrc = base64
      const file = this.base64ToBlob(base64)
      file.name = '签名.png'
      this.handleUpload([file])
    },
    // 编辑|查看
    handleSignature() {
      this.visible = true
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.formDisabledValue || this.disabled) {
            this.$refs.imageViewer.previewAttach(this.value.data)
          } else {
            this.$refs.signature.handleOpenSignature(this.imgSrc)
          }
        }, 500)
      })
    }
  }
}
</script>

<style lang="scss">
.WSign {
  height: 100%;
  width: 100%;
  .el-image,
  .placeholder {
    background: #f5f7fa;
    // border-radius: 3px;
    text-align: center;
    cursor: pointer;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
}
</style>